import { EnumDiscountType } from "gql/generated";
import { PromoCodeSummary } from "../PromoCodeSummary";
import { Table } from "@ttc3k/trekker";
import { formatPrice } from "shared/utils";
import { styled } from "styled-system/jsx";

export type DiscountItem = {
  label: string;
  total: number;
  type: EnumDiscountType;
  isMainProductOnly: boolean;
};

type DiscountItemProps = {
  discountItem: DiscountItem;
  isReservationPage?: boolean;
};

export const DiscountItem = ({
  discountItem: { label, total, type },
  isReservationPage,
}: DiscountItemProps) => {
  if (type === EnumDiscountType.PromoCode && !isReservationPage) {
    return <PromoCodeSummary key={label} label={label} total={total} />;
  }

  return (
    <Table.Row key={label}>
      <Table.Header paddingRight={"150"} lineClamp={2}>
        {label}
      </Table.Header>
      <Table.Cell>
        <styled.span whiteSpace="nowrap">-${formatPrice(total)}</styled.span>
      </Table.Cell>
    </Table.Row>
  );
};
